import { createSlice } from "@reduxjs/toolkit";

import {
  addBerthOutage,
  editBerthOutage,
  fetchBerthOutagesList,
  removeBerthOutage,
} from "../thunks/berthOutagesThunks";

import type { BerthOutage } from "../../utils/types/berthOutages";

interface BerthOutagesState {
  list: BerthOutage[];
  loading: boolean;
  error: string | null;
}

const initialState: BerthOutagesState = {
  list: [],
  loading: false,
  error: null,
};

export const berthOutagesSlice = createSlice({
  name: "berthOutages",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Fetch
    builder
      .addCase(fetchBerthOutagesList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBerthOutagesList.fulfilled, (state, action) => {
        state.list = action.payload;
        state.loading = false;
      })
      .addCase(fetchBerthOutagesList.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });

    // Add
    builder
      .addCase(addBerthOutage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addBerthOutage.fulfilled, (state, action) => {
        state.loading = false;
        state.list = [action.payload, ...state.list];
      })
      .addCase(addBerthOutage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // Edit
    builder
      .addCase(editBerthOutage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editBerthOutage.fulfilled, (state, action) => {
        state.loading = false;
        state.list = state.list.map((item) =>
          item.berthOutageId === action.payload.berthOutageId
            ? action.payload
            : item
        );
      })
      .addCase(editBerthOutage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // Remove
    builder
      .addCase(removeBerthOutage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeBerthOutage.fulfilled, (state, action) => {
        state.loading = false;
        state.list = state.list.filter(
          (item) => item.berthOutageId !== action.payload.id
        );
      })
      .addCase(removeBerthOutage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default berthOutagesSlice.reducer;
